const auks = (props) => props.children;

export default auks;